import React from "react";
import classes from "./SizeLabel.module.scss";

type Area = number | string;

interface Props {
  size?: Area;
  active: boolean;
  display: boolean;
  selectSize: () => void;
}

function SizeLabel(props: Props) {
  return (
    <span
      key={props.size}
      onClick={props.selectSize}
      className={`${classes.slider_label} ${
        props.active ? ` ${classes.active_label}` : ""
      }`}
    >
      {props.display ? props.size : ""}
    </span>
  );
}

export default SizeLabel;
